import { useState } from 'react'

export default function Sidebar({ onToggleNotify }: { onToggleNotify: () => void }) {
  return (
    <div className="styles_containerHeader__qmsyu hidden-1199">
      <div className="styles_topMenuContainer__0sPLC">
        <div className="styles_headerTop__cWk5j">
          <div className="styles_wrapperLink__VBuUw">
            {/* <a
              className="styles_linkMenu__8r7wM"
              target="_blank"
              href="https://hoptacbanhang.thuocsi.vn?utm_source=website&amp;utm_medium=topbutton&amp;utm_campaign=website_ref&amp;utm_term=202305" rel="noreferrer"
            >
              <span
              style={{
                boxSizing: 'border-box',
                display: 'inline-block',
                overflow: 'hidden',
                width: '24px',
                height: '24px',
                background: 'none',
                opacity: 1,
                border: '0px',
                margin: '0px',
                padding: '0px',
                position: 'relative',
              }}
              >
                <img
                  data-origin-url="https://cdn-web-next.thuocsi.vn/images/home/home.svg"
                  src="https://cdn-web-next.thuocsi.vn/images/home/home.svg"
                  decoding="async"
                  data-nimg="fixed"
                  alt="Home"
                  style={{
                    position: 'absolute',
                    inset: '0px',
                    boxSizing: 'border-box',
                    padding: '0px',
                    border: 'none',
                    margin: 'auto',
                    display: 'block',
                    width: '0px',
                    height: '0px',
                    minWidth: '100%',
                    maxWidth: '100%',
                    minHeight: '100%',
                    maxHeight: '100%',
                  }} /><noscript></noscript
                >
              </span>
              <p className="MuiTypography-root MuiTypography-body2">Đăng ký bán hàng</p>
            </a> */}
            <a
              className="styles_linkMenu__8r7wM"
              target="_blank"
              href="#" rel="noreferrer"
            ><span
              style={{
                boxSizing: 'border-box',
                display: 'inline-block',
                overflow: 'hidden',
                width: '24px',
                height: '24px',
                background: 'none',
                opacity: 1,
                border: '0px',
                margin: '0px',
                padding: '0px',
                position: 'relative',
              }}
            ><img
                  data-origin-url="https://cdn-web-next.thuocsi.vn/images/home/help.svg"
                  src="https://cdn-web-next.thuocsi.vn/images/home/help.svg"
                  decoding="async"
                  data-nimg="fixed"
                  alt="Help"
                  style={{
                    position: 'absolute',
                    inset: '0px',
                    boxSizing: 'border-box',
                    padding: '0px',
                    border: 'none',
                    margin: 'auto',
                    display: 'block',
                    width: '0px',
                    height: '0px',
                    minWidth: '100%',
                    maxWidth: '100%',
                    minHeight: '100%',
                    maxHeight: '100%',
                  }} /><noscript></noscript
                  ></span>
              <p className="MuiTypography-root MuiTypography-body2">Hướng dẫn đặt hàng</p></a
            ><a className="styles_linkMenu__8r7wM" href="/user/wishlist"
            ><span
              style={{
                boxSizing: 'border-box',
                display: 'inline-block',
                overflow: 'hidden',
                width: '24px',
                height: '24px',
                background: 'none',
                opacity: 1,
                border: '0px',
                margin: '0px',
                padding: '0px',
                position: 'relative',
              }}
            ><img
                  data-origin-url="https://cdn-web-next.thuocsi.vn/images/home/heart.svg"
                  src="https://cdn-web-next.thuocsi.vn/images/home/heart.svg"
                  decoding="async"
                  data-nimg="fixed"
                  alt="Heart"
                  style={{
                    position: 'absolute',
                    inset: '0px',
                    boxSizing: 'border-box',
                    padding: '0px',
                    border: 'none',
                    margin: 'auto',
                    display: 'block',
                    width: '0px',
                    height: '0px',
                    minWidth: '100%',
                    maxWidth: '100%',
                    minHeight: '100%',
                    maxHeight: '100%',
                  }} /><noscript></noscript
                  ></span>
              <p className="MuiTypography-root MuiTypography-body2">Sản phẩm quan tâm</p></a
            >
          </div>
          <div className="styles_wrapperLink__VBuUw">
            <button onClick={onToggleNotify} className="MuiButtonBase-root styles_notiContainer__6m2CD" tabIndex={0} type="button">
              <div className="styles_badgeContainer__wVKFh">
                <span
                  style={{
                    boxSizing: 'border-box',
                    display: 'inline-block',
                    overflow: 'hidden',
                    width: '14px',
                    height: '18px',
                    background: 'none',
                    opacity: 1,
                    border: '0px',
                    margin: '0px',
                    padding: '0px',
                    position: 'relative',
                  }}
                ><img
                    data-origin-url="https://cdn-web-next.thuocsi.vn/images/home/noti.svg"
                    src="https://cdn-web-next.thuocsi.vn/images/home/noti.svg"
                    decoding="async"
                    data-nimg="fixed"
                    alt="Notification"
                    style={{
                      position: 'absolute',
                      inset: '0px',
                      boxSizing: 'border-box',
                      padding: '0px',
                      border: 'none',
                      margin: 'auto',
                      display: 'block',
                      width: '0px',
                      height: '0px',
                      minWidth: '100%',
                      maxWidth: '100%',
                      minHeight: '100%',
                      maxHeight: '100%',
                    }} /><noscript></noscript
                    ></span>
              </div>
              <span className="styles_titleNoti__To2Qd">Thông báo</span>
              <span className="MuiTouchRipple-root"></span>
            </button>
            {/* <a className="styles_linkMenu__8r7wM" target="_blank" href="https://news.thuocsi.vn" rel="noreferrer">
              <span
                style={{
                  boxSizing: 'border-box',
                  display: 'inline-block',
                  overflow: 'hidden',
                  width: '24px',
                  height: '24px',
                  background: 'none',
                  opacity: 1,
                  border: '0px',
                  margin: '0px',
                  padding: '0px',
                  position: 'relative',
                }}
              ><img
                  data-origin-url="https://cdn-web-next.thuocsi.vn/images/home/paper.svg"
                  src="https://cdn-web-next.thuocsi.vn/images/home/paper.svg"
                  decoding="async"
                  data-nimg="fixed"
                  alt="Paper"
                  style={{
                    position: 'absolute',
                    inset: '0px',
                    boxSizing: 'border-box',
                    padding: '0px',
                    border: 'none',
                    margin: 'auto',
                    display: 'block',
                    width: '0px',
                    height: '0px',
                    minWidth: '100%',
                    maxWidth: '100%',
                    minHeight: '100%',
                    maxHeight: '100%',
                  }} /><noscript></noscript
                  ></span>
              <p className="MuiTypography-root MuiTypography-body2">Tin tức</p>
            </a> */}
            {/* <a className="styles_linkMenu__8r7wM" target="_blank" href="https://career.buymed.com" rel="noreferrer"
            >
              <span
              style={{
                boxSizing: 'border-box',
                display: 'inline-block',
                overflow: 'hidden',
                width: '24px',
                height: '24px',
                background: 'none',
                opacity: 1,
                border: '0px',
                margin: '0px',
                padding: '0px',
                position: 'relative',
              }}
              >
                <img
                  data-origin-url="https://cdn-web-next.thuocsi.vn/images/home/hiring.svg"
                  src="https://cdn-web-next.thuocsi.vn/images/home/hiring.svg"
                  decoding="async"
                  data-nimg="fixed"
                  alt="Hiring"
                  style={{
                    position: 'absolute',
                    inset: '0px',
                    boxSizing: 'border-box',
                    padding: '0px',
                    border: 'none',
                    margin: 'auto',
                    display: 'block',
                    width: '0px',
                    height: '0px',
                    minWidth: '100%',
                    maxWidth: '100%',
                    minHeight: '100%',
                    maxHeight: '100%',
                  }} /><noscript></noscript
                  ></span>
              <p className="MuiTypography-root MuiTypography-body2">Tuyển dụng</p>
            </a> */}
          </div>
        </div>
      </div>
      <div className="styles_headerCenter__rkkQJ !p-0">
        <a
          className="styles_mobile_rootBase__8z7PQ"
          href="https://try.thuocsi.vn/chuong-trinh-gioi-thieu-ban-be-thang12?utm_source=website&amp;utm_medium=countdown_bar&amp;utm_campaign=GTBB&amp;utm_term=202512&amp;utm_content=0"
          style={{ padding: '0px' }}
        ><div className="styles_countdownBarFullWrapper__H__ia" style={{ backgroundColor: 'rgb(255, 255, 255)' }}>
            <span
              style={{
                boxSizing: 'border-box',
                display: 'block',
                overflow: 'hidden',
                width: 'initial',
                height: 'initial',
                background: 'none',
                opacity: 1,
                border: '0px',
                margin: '0px',
                padding: '0px',
                position: 'absolute',
                inset: '0px',
              }}
            ><img
                alt="GTBB - 15.12"
                data-origin-url="https://storage.googleapis.com/thuocsi-live/images/2025cfcfb70e46398787fa2ca988ec80"
                src="https://gcs.buymed.com/thuocsi-live/images/2025cfcfb70e46398787fa2ca988ec80?quality=100"
                decoding="async"
                data-nimg="fill"
                style={{
                  position: 'absolute',
                  inset: '0px',
                  boxSizing: 'border-box',
                  padding: '0px',
                  border: 'none',
                  margin: 'auto',
                  display: 'block',
                  width: '0px',
                  height: '0px',
                  minWidth: '100%',
                  maxWidth: '100%',
                  minHeight: '100%',
                  maxHeight: '100%',
                }} /><noscript></noscript
                ></span></div
          ></a>
      </div>
    </div>
  )
}

